// import { useEffect } from "react";
// import React from "react";
// import "./index.scss";

// const scope = "name email";
// const state = "origin:web";

// // const clientId = "com.basemap.login"; // must match Service ID
// const clientId = "com.basemap.login"
// // const redirectURI = "https://tbvpnc.csb.app/"; // must match return URL
// const redirectURI = 'https://staging.basemap.com/'
// // 6754014659


// export default function App() {
//     useEffect(() => {
//         // Initialize Apple Sign In
//         window.AppleID.auth.init({
//             clientId,
//             scope,
//             redirectURI,
//             state,
//             usePopup: true,
//         });

//         // Success and failure listeners
//         document.addEventListener("AppleIDSignInOnSuccess", (event) => {
//             console.log("✅ Apple login success:", event.detail);
//         });

//         document.addEventListener("AppleIDSignInOnFailure", (event) => {
//             console.log("❌ Apple login error:", event.detail);
//         });
//     }, []);

//     // Manual trigger function
//     const handleAppleLogin = () => {
//         window.AppleID.auth.signIn(); // Opens Apple popup manually
//     };

//     return (
//         <div className="button-facebook">
//             <button
//                 style={{ backgroundColor: "rgb(51, 51, 51)", margin: "1em 0", cursor: "pointer" }}
//                 onClick={handleAppleLogin}
//             >
//                 <div style={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "center" }}>
//                     <span className="buttonText" style={{ color: "#ffffff" }}>
//                         Apple Login
//                     </span>
//                 </div>
//             </button>
//         </div>
//     );
// }



import React, { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { connect } from "react-redux";
import { appleLoginRequest } from "../../../../action/auth-actions";
import "./index.scss";

const scope = "name email";
const state = "origin:web";
// const clientId = "com.basemap.BaseMap";
const clientId = "com.basemap.ios"

// ✅ Automatically detect environment (staging or local/ngrok)

const redirectURI = "https://staging.basemap.com"; // 🔹 production/staging URL registered in Apple Dev
// const redirectURI = "https://nonsymphoniously-dorsiventral-arlena.ngrok-free.dev/"

function AppleLogin(props) {
    useEffect(() => {
        // Wait for Apple SDK to load
        if (!window.AppleID) {
            console.error("⚠️ AppleID SDK not found. Make sure you included https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js in index.html");
            return;
        }

        // Initialize Apple Sign In
        window.AppleID.auth.init({
            clientId,
            scope,
            redirectURI,
            state,
            usePopup: true,
        });

        const handleSuccess = (event) => {
            const { authorization, user } = event.detail;

            if (!authorization?.id_token) {
                console.error("❌ Apple sign-in succeeded but id_token is missing");
                return;
            }

            const decoded = jwtDecode(authorization.id_token);
            const userInfo = {
                userID: decoded.sub,
                identityToken: authorization.id_token,
                authorizationCode: authorization.code,
                email: decoded.email || user?.email
            };

            props.appleLoginRequest(userInfo)
                .then((res) => { console.log("Apple login response:", res) })
                .catch((err) => {
                    console.error("Apple login error:", err)
                    if (props.onLoginError) props.onLoginError("apple", userInfo.email, err)
                });
        };

        const handleFailure = (event) => {
            console.error("❌ Apple login failed:", event.detail);
        };

        document.addEventListener("AppleIDSignInOnSuccess", handleSuccess);
        document.addEventListener("AppleIDSignInOnFailure", handleFailure);

        return () => {
            document.removeEventListener("AppleIDSignInOnSuccess", handleSuccess);
            document.removeEventListener("AppleIDSignInOnFailure", handleFailure);
        };
    }, []);

    const handleAppleLogin = () => {
        if (window.AppleID?.auth) {
            window.AppleID.auth.signIn();
        } else {
            console.error("AppleID SDK not loaded. Check that script is included before running the app.");
        }
    };

    return (
        <div className="button-facebook">
            <button
                style={{ backgroundColor: "rgb(51, 51, 51)", margin: "1em 0", cursor: "pointer" }}
                onClick={handleAppleLogin}
            >
                <div style={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "center" }}>
                    <span className="buttonText" style={{ color: "#ffffff" }}>
                        Apple Login
                    </span>
                </div>
            </button>
        </div>
    );
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    login: (bmAuthObj) => dispatch(login(bmAuthObj)),
    appleLoginRequest: (payload) => dispatch(appleLoginRequest(payload, { createUser: false }))
});

export default connect(mapStateToProps, mapDispatchToProps)(AppleLogin);
